module.exports = __webpack_public_path__ + "img/cinvestav.00249733.jpg";